import { useContext } from 'react';

import { NavigationBlockerContext } from '../components/NavigationBlocker';

import { useBlocker } from './useBlocker/useBlocker';

/**
 * A hook to show the message prompt to prevent users from jumping to another route directly
 * @param shouldBlockNavigation - whether we should show the prompt when route change is detected
 */
export function useRouteChangePrompt(shouldBlockNavigation: boolean): void {
  /** Retry navigating to a page; called after the navigation is confirmed */
  const { setBlockedTransition } = useContext(NavigationBlockerContext);

  useBlocker(setBlockedTransition, shouldBlockNavigation);
}
